import { createContext } from 'react';

// Contains published CMS content only, never visitor details or auth state.
export const PrerenderData = createContext(null);
export function readPrerenderData() {
  const element = document.getElementById('haven-prerender-data');
  if (!element) return null;
  try { return JSON.parse(element.textContent); } catch { return null; }
}
